import { createSelector } from 'reselect'

const selectFilters = state => state.screens.SubcontractorSubOrders.filters

export default createSelector(
  selectFilters,
  (filters) => {

    if (filters.date_range.length) return true

    return false

  },
)
